import React from 'react';

import classnames from 'classnames';
import { connect } from 'react-redux';

import { MODALS } from 'global-constants';
import image from 'assets/images/homepage/dashboard_screenshot.png';

import { openModal } from 'shared/components/Modals/reducer';

import Image from 'shared/components/Image';
import Button from 'shared/components/Button';

import styles from './styles.module.scss';

const Community = ({ openModal }) => (
  <div className={styles.wrapper}>
    <div className={classnames('container', styles.container)}>
      <div className={styles.left}>
        <div className={styles.title}>What Is Unissu?</div>
        <div className={styles.description}>
          Unissu's trusted PropTech procurement service is utilised by leading
          technology companies to identify cost-effective, qualified sales
          leads.<br />
          <br />
          Our community brings together the leaders in innovation and change in
          the built environment, from all sides of the market, to learn,
          discover and connect at this exciting time in the real estate
          industry!
        </div>
        <Button
          color="orange-gradient"
          className={styles.button}
          onClick={() => openModal({ modalName: MODALS.SIGNUP })}>
          Join Now!
        </Button>
      </div>

      <div className="remove-sm">
        <Image
          src="https://s3.eu-west-2.amazonaws.com/unissu.com/assets/images/unissuegraphic.png"
          height="auto"
          width="628"
        />
      </div>
      <div className="remove-md-min">
        <Image
          src="https://s3.eu-west-2.amazonaws.com/unissu.com/assets/images/unissuegraphic.png"
          width="100%"
        />
      </div>
    </div>
  </div>
);

const mapStateToProps = state => ({});

const mapDispatchToProps = { openModal };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Community);
